
import React from 'react';
import { Typography, Box, Grid, Container } from '@mui/material';
import PumpCreation from './PumpCreation';
import PumpUpdateDelete from './PumpUpdateDelete';
import { styled } from '@mui/material/styles';
import { useAuth } from '../../../AuthContext';

const PageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: '#f5f5f5',
  minHeight: '100vh',
}));

const PumpManagementPage = () => {
  const { userRole } = useAuth();
  const canWrite = userRole === "admin" || userRole === "manager";

  return (
    <PageContainer>
      <Container maxWidth="lg">
        <Typography variant="h2" className="mb-8 text-gray-800 font-bold text-center">
          Pump Management
        </Typography>
        {canWrite ? (
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <PumpCreation />
            </Grid>
            <Grid item xs={12} md={6}>
              <PumpUpdateDelete />
            </Grid>
          </Grid>
        ) : (
          <Typography variant="body1" color="text.secondary" textAlign="center" mt={4}>
            You have view-only access. Contact an admin to make changes.
          </Typography>
        )}
      </Container>
    </PageContainer>
  );
};

export default PumpManagementPage;

